if (!customElements.get('product-share-dropdown')) {
  var globalShareToast = null;
  var globalShareToastTimer = null;

  function getGlobalShareToast() {
    if (!globalShareToast) {
      globalShareToast = document.createElement('div');
      globalShareToast.className = 'product-share-toast';
      globalShareToast.setAttribute('role', 'status');
      globalShareToast.setAttribute('aria-live', 'polite');
      document.body.appendChild(globalShareToast);
    }

    return globalShareToast;
  }

  function showShareToast(message) {
    var toast = getGlobalShareToast();
    toast.textContent = message;
    toast.classList.add('is-visible');

    if (globalShareToastTimer) {
      window.clearTimeout(globalShareToastTimer);
    }

    globalShareToastTimer = window.setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 3000);
  }

  customElements.define(
    'product-share-dropdown',
    class ProductShareDropdown extends HTMLElement {
      connectedCallback() {
        this.toggle =
          this.querySelector('.product-share-dropdown__toggle') ||
          this.querySelector('.card-share-toggle');
        this.menu = this.querySelector('.product-share-dropdown__menu');
        this.instagramLink = this.querySelector('[data-action="instagram"]');
        this.isCard =
          this.classList.contains('product-share-dropdown--card') ||
          this.classList.contains('product-share-dropdown--pdp');
        this.shareUrl = this.dataset.shareUrl || window.location.href;
        this.shareText = this.dataset.shareText || this.shareUrl;
        this.instagramShareText = this.dataset.instagramShareText || this.shareUrl;
        this.copiedMessage = this.dataset.copiedMessage || 'Link copied to clipboard!';
        this.instagramDesktopMessage =
          this.dataset.instagramDesktopMessage || 'Open this page on your phone to share on Instagram';
        this.instagramOpeningMessage =
          this.dataset.instagramOpeningMessage || 'Opening Instagram...';

        this.onToggleClick = this.onToggleClick.bind(this);
        this.onActionClick = this.onActionClick.bind(this);
        this.onDocumentClick = this.onDocumentClick.bind(this);
        this.onDocumentKeydown = this.onDocumentKeydown.bind(this);

        if (!this.toggle || !this.menu) return;

        if (this.instagramLink) {
          this.instagramLink.href = this.buildInstagramUrl();
        }

        this.toggle.addEventListener('click', this.onToggleClick);
        this.addEventListener('click', this.onActionClick);
        document.addEventListener('click', this.onDocumentClick);
        document.addEventListener('keydown', this.onDocumentKeydown);
      }

      disconnectedCallback() {
        if (!this.toggle) return;

        this.toggle.removeEventListener('click', this.onToggleClick);
        this.removeEventListener('click', this.onActionClick);
        document.removeEventListener('click', this.onDocumentClick);
        document.removeEventListener('keydown', this.onDocumentKeydown);
      }

      buildInstagramUrl() {
        var isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

        if (!isMobile) {
          return '#';
        }

        return 'instagram://sharesheet?text=' + this.instagramShareText;
      }

      closeOtherDropdowns() {
        document.querySelectorAll('product-share-dropdown.is-open').forEach(
          function (dropdown) {
            if (dropdown !== this) {
              dropdown.setOpen(false);
            }
          }.bind(this)
        );
      }

      onToggleClick(event) {
        event.preventDefault();
        event.stopPropagation();

        if (!this.isOpen()) {
          this.closeOtherDropdowns();
        }

        this.setOpen(!this.isOpen());
      }

      onDocumentClick(event) {
        if (!this.contains(event.target)) {
          this.setOpen(false);
        }
      }

      onDocumentKeydown(event) {
        if (event.key === 'Escape') {
          this.setOpen(false);
        }
      }

      onActionClick(event) {
        event.stopPropagation();

        var option = event.target.closest('[data-action]');
        if (!option || !this.contains(option)) return;

        var action = option.dataset.action;

        if (action === 'copy') {
          event.preventDefault();
          this.copyLink();
          return;
        }

        if (action === 'instagram') {
          if (!/Android|iPhone|iPad|iPod/i.test(navigator.userAgent)) {
            event.preventDefault();
            this.setOpen(false);
            showShareToast(this.instagramDesktopMessage);
            return;
          }

          this.setOpen(false);
          showShareToast(this.instagramOpeningMessage);
        }
      }

      isOpen() {
        return this.toggle.getAttribute('aria-expanded') === 'true';
      }

      setOpen(isOpen) {
        this.toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        this.menu.hidden = !isOpen;
        this.classList.toggle('is-open', isOpen);
      }

      writeTextToClipboard(text) {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          return navigator.clipboard.writeText(text).catch(function () {
            return Promise.resolve();
          });
        }

        var input = document.createElement('textarea');
        input.value = text;
        input.setAttribute('readonly', '');
        input.style.position = 'fixed';
        input.style.left = '-9999px';
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);
        return Promise.resolve();
      }

      copyLink() {
        this.setOpen(false);
        showShareToast(this.copiedMessage);
        this.writeTextToClipboard(this.shareUrl);
      }
    }
  );
}
